import $ from 'jquery';

import Navigation from './Controllers/Navigation';
import MobileMenu from './Controllers/MobileMenu';
import CampaignSticker from './Controllers/CampaignSticker';
import Analytics from './Controllers/Analytics';
import Lightbox from './Controllers/Lightbox';
import ScrollMonitor from './Controllers/ScrollMonitor';
import Video from './Controllers/Video';
import VideoLoop from './Controllers/VideoLoop';
import ThumbnailGalleryController from './Controllers/ThumbnailGallery';
import SidebarController from './Controllers/Sidebar';
import MastheadCompactNavController from './Controllers/MastheadCompact';

export let NCST = {};

( function ( window, document, NCST ) {
	'use strict';

	var resizeTimer, mouseMoveTimeout, lastScrollPos;

	NCST.controllers = {
		scrollmonitor: new ScrollMonitor(),
		navigation: new Navigation(),
		mobileMenu: new MobileMenu(),
		campaignSticker: new CampaignSticker(),
		analytics: new Analytics(),
		video: new Video(),
		videoLoop: new VideoLoop(),
		lightbox: new Lightbox(),
		thumbnailGallery: new ThumbnailGalleryController(),
		sidebar: new SidebarController(),
		mastheadCompact: new MastheadCompactNavController()
	};

	NCST.features = {
		mouseUsed: false,
	};

	//init everything on DOM ready
	NCST.init = function () {
		//global jQuery objects for reuse
		NCST.elements = {
			$doc: $( document ),
			$win: $( window ),
			$html: $( 'html' ),
			$body: $( 'body' ),
			$htmlBody: $( 'html, body' ),
		};

		NCST.state = {
			isScrollDown: true,
		};

		self.detectFeatures();

		// init global resources
		self.initUbSearchTrack();
		self.initClickHandlers();
		self.initResizeEndEvent();
		self.initScrollDirection();

		// init all controllers
		$.each( NCST.controllers, ( index, controller ) => {
			controller.init();
		} );
	};

	/**
	 * Adds or overrides controllers.
	 *
	 * @param {object} controllers Object of named controllers.
	 */
	NCST.registerControllers = function ( controllers ) {
		NCST.extend( NCST.controllers, controllers );
	};

	/**
	 * Merges object 2 into object 1 overwriting any
	 * common properties.
	 *
	 * @param  {object} o1 An object with props
	 * @param  {object} o2 An object with props
	 */
	NCST.extend = function ( o1, o2 ) {
		for ( var prop in o2 ) {
			if ( o2.hasOwnProperty( prop ) ) {
				o1[ prop ] = o2[ prop ];
			}
		}
	};

	/**
	 * Tests user agent for iOS indicators.
	 */
	NCST.isIOS = function () {
		return /iPhone|iPad|iPod/i.test( navigator.userAgent )  ||
			( navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 );
	};

	/**
	 * Cross-browser requestAnimationFrame.
	 *
	 * From Waypoints
	 * https://github.com/imakewebthings/waypoints/blob/master/src/context.js#L301
	 */
	NCST.requestAnimationFrame = function ( callback ) {
		var requestFn =
			window.requestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			requestAnimationFrameShim;
		requestFn.call( window, callback );
	};

	var requestAnimationFrameShim = function ( callback ) {
		window.setTimeout( callback, 1000 / 60 );
	};

	var self = {
		// ********************************************************************************
		// Main Init Methods
		// ********************************************************************************

		initUbSearchTrack: function () {
			setTimeout( function () {
				if ( $( '.ncstate-utility-bar-search-field' ).length > 0 ) {
					$( '.ncstate-utility-bar-search-form' ).on(
						'submit',
						function () {
							var term = $(
								'.ncstate-utility-bar-search-field'
							)[ 0 ].value;
							NCST.controllers.analytics.ubSearch( term );
						}
					);
				} else {
					// UB insn't in the DOM yet, so keep trying to init every 1 second.
					self.initUbSearchTrack();
				}
			}, 1000 );
		},

		initClickHandlers: function () {
			$( '.js-share' ).click( self.sharePopup );
			$( '.panel-collapse' ).on(
				'shown.bs.collapse',
				self.handleBootstrapCollapse
			);
		},

		initResizeEndEvent: function () {
			NCST.elements.$win.on( 'resize', function () {
				NCST.elements.$body.addClass( 'resizing' );

				clearTimeout( resizeTimer );
				resizeTimer = setTimeout( function () {
					NCST.elements.$body.removeClass( 'resizing' );
					NCST.elements.$win.trigger( 'ncst_resized' );
				}, 250 );
			} );
		},

		initScrollDirection: function () {
			NCST.elements.$win.scroll( function () {
				let newScrollPos =
					window.pageYOffset || document.documentElement.scrollTop;

				/*
				 * Scroll monitor and jQuery are inconsistent
				 * in their handling of viewport and document heights. Using
				 * each in this particular combination is required.
				 */
				let isOverscroll =
					newScrollPos +
						NCST.controllers.scrollmonitor.get().viewportHeight >=
					NCST.elements.$doc.height();

				if ( isOverscroll ) {
					return;
				}

				if ( newScrollPos > lastScrollPos ) {
					lastScrollPos = newScrollPos;
					NCST.state.isScrollDown = true;
				} else {
					lastScrollPos = newScrollPos;
					NCST.state.isScrollDown = false;
				}
			} );
		},

		// ********************************************************************************
		// Handlers
		// ********************************************************************************

		sharePopup: function ( e ) {
			var windowOptions =
					'scrollbars=yes,resizable=yes,toolbar=no,location=yes',
				winWidth = screen.width,
				winHeight = screen.height,
				width = 550,
				height = 420,
				left = Math.round( winWidth / 2 - width / 2 ),
				top = 0;

			if ( winHeight > height ) {
				top = Math.round( winHeight / 2 - height / 2 );
			}

			window.open(
				$( this ).attr( 'href' ),
				'intent',
				windowOptions +
					',width=' +
					width +
					',height=' +
					height +
					',left=' +
					left +
					',top=' +
					top
			);

			e.preventDefault();
		},

		handleBootstrapCollapse: function ( e ) {
			var $panel = $( this ).closest( '.panel' );
			if (
				$panel.length > 0 &&
				$panel.offset().top < NCST.elements.$win.scrollTop()
			) {
				NCST.elements.$htmlBody.animate(
					{
						scrollTop: $panel.offset().top - 50,
					},
					500
				);
			}
		},

		/**
		 * From PhotoSwipe.
		 * https://github.com/dimsemenov/PhotoSwipe/blob/master/src/js/core.js#L224
		 */
		onFirstMouseMove: function () {
			// Wait until mouse move event is fired at least twice during 100ms
			// We do this, because some mobile browsers trigger it on touchstart
			if ( mouseMoveTimeout ) {
				NCST.elements.$doc.off(
					'mousemove',
					null,
					self.onFirstMouseMove
				);
				NCST.elements.$body.addClass( 'has_mouse' );
				NCST.features.mouseUsed = true;
			}
			mouseMoveTimeout = setTimeout( function () {
				mouseMoveTimeout = null;
			}, 100 );
		},

		// ********************************************************************************
		// Helpers
		// *****************************************************************************

		detectFeatures: function () {
			// Add class for iOS
			if ( NCST.isIOS() ) {
				NCST.elements.$html.addClass( 'isIOS' );
			}

			// Add listener to detect mouse usage.
			NCST.elements.$doc.on( 'mousemove', self.onFirstMouseMove );

			// Check for accessibility concerns with motion
			const mediaQuery = window.matchMedia( '(prefers-reduced-motion: reduce)' );
			if ( mediaQuery.matches ) {
				NCST.elements.$html.addClass( 'prefers-reduced-motion' );
			}

		},
	};
} )( window, document, NCST );

export { ControllerComponent } from './Controllers/ControllerComponent';
